import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api";
import { Link } from 'react-router-dom'
import LazyLoad from "react-lazyload";
const removeHtmlTags = (str) => {
  return str.replace(/<[^>]*>/g, ''); // Removes anything between '<' and '>'
};
const PrincipalDesk = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);
  const emptyArray = [
    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },   
  ];
  return (
    <>
      <div className="breadcrumb">

        <h2> Principal's Desk</h2>
        <ul>
          <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
          <li>|</li>
          <li>Principal's Desk</li>
        </ul>
      </div>
      <div className="inner_page">

        <div className="container">

          {data?.length > 0 ? data?.filter((div) => div.category === "Principal").map((item, index) => (
            <div className="row message_inner">
              <div className="col-lg-4 col-md-4">
                <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments}`} className="inner_img img-fluid" alt="St Francis School, Amritsar" /></LazyLoad>
              </div>
              <div className="col-lg-8 col-md-8 messagebox">
                <p>{removeHtmlTags(item.message)}</p> 
                <h4>{item.name} </h4>
                <h5><strong> {item.category} </strong></h5><div className="clr"></div>
              </div>
            </div>
          )) : emptyArray.map((data, index) => (<div key={index} className='row'>
            <div className="row message_inner">
              <div className="col-lg-4 col-md-4">
                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/principal.png" className="inner_img img-fluid" alt="St Francis School, Amritsar" /></LazyLoad>
              </div>
              <div className="col-lg-8 col-md-8 messagebox">
                <p>One child, One teacher, One book. One pen can change the world. Let us the little children come to me, do not stop them, for it is to such as these that the kingdom of God belongs.</p>
                <h4>SR. SOOSAI MARY </h4>
                <h5><strong>PRINCIPAL</strong></h5><div className="clr"></div>
              </div>
            </div>
          </div>
          ))}
        </div>

      </div>
    </>
  )
}

export default PrincipalDesk
